













































































import {Component, Vue, Prop} from 'vue-property-decorator';
import Building from '@/data/models/building';
import IdentityForm from '@/components/buildings/IdentityForm.vue';
import ConfigForm from '@/components/buildings/ConfigForm.vue';
import Button from '@/components/commons/Button.vue';
import Planning from '@/components/buildings/Planning.vue';
import dayjs from "dayjs";

@Component({
  components: {Planning, Button, ConfigForm, IdentityForm},
})
export default class CreateUpdateBuilding extends Vue {

  @Prop({required: true})
  uid: string;

  tabIndex: number = 0;
  building: Building = null;
  isFormValid: boolean = false;

  mounted(): void {
    if (this.$route.query.buildingId != null) {
      this.$dao.buildings.getById(this.$route.query.buildingId.toString()).then(
          (result) => {
            this.building = result;
          },
      );
    } else {
      this.building = Building.map({buildDate: dayjs().toDate(), clientId: this.uid});
    }
  }

  get isCreated(): boolean {
    return this.$route.query.buildingId == null;
  }

  handleClick(): void {
    this.isCreated ? this.createBuilding() : this.updateBuilding();
  }

  createBuilding(): void {
    this.$store.commit("showLoader", true);
    this.$dao.buildings.create(this.building.toJSON()).then((result) => {
      if (result != null) {
        this.$router.go(-1);
      } else {
        throw 'err';
      }
    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.createBuilding').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
    }).finally(() => this.$store.commit("showLoader", false));
  }

  updateBuilding(): void {
    this.$store.commit("showLoader", true);
    this.$dao.buildings.update(this.building.toJSON(), this.building.id).then((result) => {
      if (result != null) {
        this.$router.go(-1);
      } else {
        throw 'err';
      }
    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.updateBuilding').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
    }).finally(() => this.$store.commit("showLoader", false));
  }
}
